import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import {
  ProductionListPropertyResolveSpec,
  ProductionListPropertyResolveType,
} from '../production-list-property-resolve-spec'
import { AttachmentSpecType } from '../../../../attachments/spec/attachment-spec'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ActionSelectDirective } from '../../../../process/actions/action-select/action-select.directive'
import { AttachmentSpecDetailComponent } from '../../../../attachments/spec/attachment-spec-detail/attachment-spec-detail.component'
import { PropertySelectDirective } from '../../../../properties/property-select/property-select.directive'
import { KnownProductionListPropertySelectDirective } from '../known-production-list-property-select.directive'
import { ProductionListPropertyResolveTypeSelectDirective } from '../production-list-property-resolve-type-select.directive'
import { ElderSelectComponent, ElderSelectValueDirective } from '@elderbyte/ngx-starter'
import { MatFormField } from '@angular/material/form-field'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-item-property-resolve-spec-detail',
  templateUrl: './production-list-property-resolve-spec-detail.component.html',
  styleUrls: ['./production-list-property-resolve-spec-detail.component.scss'],
  imports: [
    MatFormField,
    ElderSelectComponent,
    ProductionListPropertyResolveTypeSelectDirective,
    KnownProductionListPropertySelectDirective,
    PropertySelectDirective,
    ElderSelectValueDirective,
    AttachmentSpecDetailComponent,
    ActionSelectDirective,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class ProductionListPropertyResolveSpecDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly _resolveSpec$ = new BehaviorSubject<ProductionListPropertyResolveSpec>(null)

  public ProductionListPropertyResolveType = ProductionListPropertyResolveType

  public AttachmentSpecType = AttachmentSpecType

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set resolveSpec(spec: ProductionListPropertyResolveSpec) {
    this._resolveSpec$.next(spec)
  }

  public get resolveSpec(): ProductionListPropertyResolveSpec {
    return this._resolveSpec$.getValue()
  }

  public get resolveSpec$(): Observable<ProductionListPropertyResolveSpec> {
    return this._resolveSpec$.asObservable()
  }

  /***************************************************************************
   *                                                                         *
   * Component Events                                                        *
   *                                                                         *
   **************************************************************************/

  public showProperty(): boolean {
    if (this.resolveSpec) {
      switch (this.resolveSpec.type) {
        case ProductionListPropertyResolveType.KNOWN_PROPERTY:
          return false
        case ProductionListPropertyResolveType.RESOLVED_PROPERTY:
          return true
        case ProductionListPropertyResolveType.ATTACHMENT:
          return false
      }
    }
    return false
  }

  public showAction(): boolean {
    if (this.resolveSpec) {
      switch (this.resolveSpec.type) {
        case ProductionListPropertyResolveType.KNOWN_PROPERTY:
          return false
        case ProductionListPropertyResolveType.RESOLVED_PROPERTY:
          return true
        case ProductionListPropertyResolveType.ATTACHMENT:
          return this.resolveSpec.attachment?.type === AttachmentSpecType.SEGMENT_IMAGE
      }
    }
    return false
  }
}
